import React, { memo } from "react";
import PropertyPerformanceRow from "./PropertyPerformanceRow";
import { SlaPropertyRow } from "../types";

interface Props {
  properties: SlaPropertyRow[];
}

// The `properties` array is filtered to the current user's ADMIN properties
// by the backend (Sla::DashboardSummary). This component renders the list
// verbatim and shows the empty state when no admin properties have SLA tasks.
const PropertyPerformanceTable = ({ properties }: Props) => {
  if (!properties || properties.length === 0) {
    return (
      <div className="bg-white rounded shadow-sm mb-6">
        <div className="px-5 py-4 border-b border-black-10">
          <h3 className="text-18 font-bold">Property Performance Comparison</h3>
        </div>
        <div className="py-8 text-center text-black-40 text-14">
          No properties with SLA-tracked tasks found.
        </div>
      </div>
    );
  }

  return (
    <div className="bg-white rounded shadow-sm mb-6">
      <div className="px-5 py-4 border-b border-black-10 flex items-center justify-between">
        <h3 className="text-18 font-bold">Property Performance Comparison</h3>
        <div className="text-13 text-black-40">{properties.length} properties</div>
      </div>
      {properties.map((row) => (
        <PropertyPerformanceRow key={row.property_id} row={row} />
      ))}
    </div>
  );
};

export default memo(PropertyPerformanceTable);
